import { Box } from '@mui/material';
import { TextFieldFormik } from '@vxui/components';
import { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

const inputSize = 'small';

type PasswordFormProps = {
  isReset?: boolean;
};

export const PasswordForm: FC<PasswordFormProps> = ({ isReset = false }) => {
  const { t } = useTranslation();
  const label = useCallback((fieldName: string) => t(`auth.forms.password.fields.${fieldName}.title`), [t]);
  const placeholder = useCallback((fieldName: string) => t(`auth.forms.password.fields.${fieldName}.placeholder`), [t]);

  return (
    <Box marginBottom="20px" component="form">
      {!isReset && (
        <TextFieldFormik
          name="oldPassword"
          size={inputSize}
          label={label('oldPassword')}
          placeholder={placeholder('oldPassword')}
          type="password"
          autoComplete="current-password"
        />
      )}
      <TextFieldFormik
        name="newPassword"
        size={inputSize}
        label={label('newPassword')}
        placeholder={placeholder('newPassword')}
        type="password"
        autoComplete="new-password"
      />
      <TextFieldFormik
        name="confirmedNewPassword"
        size={inputSize}
        label={label('confirmedNewPassword')}
        placeholder={placeholder('confirmedNewPassword')}
        type="password"
        autoComplete="new-password"
      />
    </Box>
  );
};
